export default {
  appId: '474168566102860',
  cookie: true,
  xfbml: false,
  version: 'v2.5'
};



/** WEBPACK FOOTER **
 ** ./config/index.js
 **/